import React, { useContext, useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import Button from "../common/Button";
import toBlob from "canvas-to-blob";

import { ReactComponent as ArrowRightSvg } from "../../assets/icons/arrow-right.svg";
import { ReactComponent as ArrowLeftSvg } from "../../assets/icons/arrow-left.svg";
import NewProjectContext from "../../contexts/NewProjectContext";
import ReactPannellum, {
  addScene,
  loadScene,
  removeScene,
  resize,
  getViewer,
  getViewers,
} from "react-pannellum";

import AppContext from "../../AppContext";
import { langComponent } from "../../constants";
import { uuidv4 } from "../../helpers/common.helper";
import LoadCover from "./LoadCover";

let coverViewer = null;

const SelectCover = (props) => {
  const { getLang } = useContext(AppContext);
  const Translation = getLang(langComponent.project);
  const TranslationCommon = getLang(langComponent.common);
  const { goForward, goBackward, details, setDetails } =
  useContext(NewProjectContext);
  const { type, panoramaImages, images } = details;
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const pannellumRef = useRef();
  const [init, setInit] = useState(false);
  const [isLoadingCovers, setIsLoadingCovers] = useState(type === "panorama");
  const [panoramaCovers, setPanoramaCovers] = useState([]);


  const _baseConfigs = {
    autoLoad: true,
    orientationOnByDefault: false,
    keyboardZoom: false,
    disableKeyboardCtrl: true,
    showControls: false,
    pitch: 0,
    yaw: 0,
  };

  useEffect(() => {
    return () => {
      if (!coverViewer) return;
      coverViewer.destroy();
      coverViewer = null;
    };
  }, []);

  useEffect(() => {
    if (!init) return;

    if (type !== "panorama") return;

    for (let i = 0; i < details.panoramaImages.length; i++) {
      if (selectedImageIndex === i) continue;

      const image = details.panoramaImages[i];

      const sceneId = image.name;

      const imageSource = URL.createObjectURL(image);

      removeScene(sceneId);
      addScene(
        sceneId,
        {
          ..._baseConfigs,
          imageSource,
        },
        () => {
          console.log("scene added");
        }
      );
    }

    coverViewer = getViewer();
    setInit(true);
  }, [details.panoramaImages, init, type]);

  useEffect(() => {
    if (type !== "panorama") return;
    loadScene(panoramaImages[selectedImageIndex].name);
  }, [selectedImageIndex]);

  const handleReturn = () => {
    setDetails((curr) => ({
      ...curr,
      cover: selectedImageIndex,
    }));
    goBackward();
  };

  const handleContinue = async () => {
    // * Type => Panorama
    if (type === "panorama") {
      const viewer = getViewer();

      const base64Data = viewer
        .getRenderer()
        .render(
          (viewer.getPitch() / 180) * Math.PI,
          (viewer.getYaw() / 180) * Math.PI,
          (viewer.getHfov() / 180) * Math.PI,
          { returnImage: true }
        );

      const cover = toBlob(base64Data);

      setDetails((curr) => ({
        ...curr,
        cover,
        panoramaCovers,
      }));
      goForward();
      return;
    }

    // * Type => Images
    setDetails((curr) => ({
      ...curr,
      cover: images[selectedImageIndex],
      panoramaCovers: [],
    }));

    goForward();
  };

  const handleSelectImage = (index) => {
    setSelectedImageIndex(index);
  };

  if (isLoadingCovers) {
    return (
      <LoadCover
        images={details.panoramaImages ?? []}
        onLoaded={(imageCovers) => {
          setPanoramaCovers(imageCovers);
          setIsLoadingCovers(false);
        }}
      />
    );
  }

  return (
    <div className="new-project-select-cover">
      <h1 className="new-project-select-cover__header">
        {Translation("Select Banner")}
      </h1>
      <h3 className="new-project-select-cover__sub">
        {Translation(
          "Select image, pan around and click continue to use current view as the cover image"
        )}
      </h3>
      <div className="new-project-select-cover-selected">
        {type === "panorama" && (
          <ReactPannellum
            sceneId={panoramaImages[0].name}
            id={uuidv4()}
            ref={pannellumRef}
            onPanoramaLoaded={() => {
              if (init) return;
              setInit(true);
            }}
            imageSource={URL.createObjectURL(panoramaImages[0])}
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
            }}
            config={{
              ..._baseConfigs,
            }}
          />
        )}
        {type === "images" && (
          <img
            className="new-project-select-cover-selected__image"
            alt=""
            src={URL.createObjectURL(images[selectedImageIndex])}
          />
        )}
      </div>
      <div className="new-project-select-cover-gallery-scroller">
        <div className="new-project-summary-gallery">
          {type === "panorama" &&
            panoramaCovers.map((src, index) => {
              return (
                <div
                  key={`pano-${index}`}
                  className={`new-project-select-cover-gallery-image ${
                    index === selectedImageIndex
                      ? "new-project-select-cover-gallery-image--active"
                      : ""
                  }`}
                  onClick={() => handleSelectImage(index)}
                >
                  <img
                    className="new-project-select-cover-gallery-image__preview"
                    alt="preview image"
                    src={src}
                  />
                </div>
              );
            })}
          {type === "images" &&
            images.map((imageFile, index) => {
              return (
                <div
                  key={`img-${index}`}
                  className={`new-project-select-cover-gallery-image ${
                    index === selectedImageIndex
                      ? "new-project-select-cover-gallery-image--active"
                      : ""
                  }`}
                  onClick={() => handleSelectImage(index)}
                >
                  <img
                    className="new-project-select-cover-gallery-image__preview"
                    alt="preview image"
                    src={URL.createObjectURL(imageFile)}
                  />
                </div>
              );
            })}
        </div>
      </div>
      <div className="new-project-select-cover-footer">
        <Button
          label={TranslationCommon("Return")}
          variant={"secondary"}
          leadingIcon={<ArrowLeftSvg />}
          onClick={handleReturn}
        />
        <Button
          label={TranslationCommon("Continue")}
          trailingIcon={<ArrowRightSvg />}
          onClick={handleContinue}
        />
      </div>
    </div>
  );
};

SelectCover.propTypes = {};

export default SelectCover;
